// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snapshots-info-box__column {
  margin-top: 2px;
  display: flex;
}

@media (width >= 992px) {
  .snapshots-info-box__column {
    margin-top: 0;
  }

  .snapshots-info-box__column:last-of-type {
    margin-top: 2px;
  }
}

@media (width >= 1408px) {
  .snapshots-info-box__column:last-of-type {
    margin-top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/InfoBoxes/InfoBoxes.css","webpack://./services/frontend/app/pages/SnapshotManagement/InfoBoxes/InfoBoxes.css"],"names":[],"mappings":"AADA;ECEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".snapshots-info-box__column {\n  display: flex;\n  margin-top: 2px;\n}\n\n  @media (min-width: 992px) {.snapshots-info-box__column {\n    margin-top: 0\n}\n\n    .snapshots-info-box__column:last-of-type {\n      margin-top: 2px;\n    }\n  }\n\n  @media (min-width: 1408px) {\n    .snapshots-info-box__column:last-of-type {\n      margin-top: 0;\n    }\n  }\n",".snapshots-info-box__column {\n  margin-top: 2px;\n  display: flex;\n}\n\n@media (width >= 992px) {\n  .snapshots-info-box__column {\n    margin-top: 0;\n  }\n\n  .snapshots-info-box__column:last-of-type {\n    margin-top: 2px;\n  }\n}\n\n@media (width >= 1408px) {\n  .snapshots-info-box__column:last-of-type {\n    margin-top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
